import { render, staticRenderFns } from "./InvalidToken.vue?vue&type=template&id=65b81f96&scoped=true&"
var script = {}
import style0 from "./InvalidToken.vue?vue&type=style&index=0&id=65b81f96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b81f96",
  null
  
)

export default component.exports